import docReady from '../../../assets/js/docReady';
import { registerPostalCheck } from '../../../assets/js/helpers/postalCheck';
import './energyProviderPage.scss';
import '../../shared/youtubeVideo/youtubeVideo';
import { loadOrderFlow } from '../../../assets/js/helpers/orderFlow';
import { clickableTable } from '../../../assets/js/helpers/table';

docReady(() => {
    // Bind to postal fields:
    const postalChecks = Array.from(document.getElementsByClassName('postal-check-component'));
    // Check if we need to resume the flow
    // Move to helper prolly
    let orderFlowChecked = false;
    const resume = JSON.parse(window.sessionStorage.getItem('resumeOrderFlow'));
    postalChecks.forEach((postalCheck) => {
        registerPostalCheck(postalCheck);
        if (postalCheck.dataset.orderFlow && !orderFlowChecked && resume) {
            orderFlowChecked = true;
            loadOrderFlow(resume)
                .then(() => {
                    window.sessionStorage.setItem('resumeOrderFlow', 'false');
                });
        }
    });

    document.querySelectorAll('#aanbiedingen table').forEach(clickableTable);

    const toggles = document.querySelectorAll('.tariff-table-toggle');
    const tables = document.querySelectorAll('.tariff-table');

    tables.forEach(table => {
        table.addEventListener('transitionend', () => {
            if (!table.classList.contains('active')) {
                table.style.display = 'none';
            }
        });
    });
    toggles.forEach(toggle => {
        toggle.addEventListener('change', () => {
            tables.forEach((table) => {
                if (table.dataset.index !== toggle.dataset.index) {
                    table.classList.remove('active');
                } else {
                    table.style.display = 'grid';
                    requestAnimationFrame(() => {
                        table.classList.add('active');
                    });
                }
            })
        })
    });
});
